<svelte:head>
<!--    <script  src="../dist/echarts.min.js" on:load={echartsLoaded} crossorigin="anonymous" defer></script>  
-->

</svelte:head>

<script>

//
//  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
//     import defaultExport from "module-name";
//     import * as name from "module-name";
//     import { export1 } from "module-name";
//     import { export1 , export2 as alias2 , [...] } from "module-name";
//     import "module-name";
//     var promise = import("module-name");
//

import { onMount, onDestroy } from 'svelte';


import { cubejsclient_service  , cubejsclient_service_context_key   } from '../_services/cubejsClient.js';

//import MySvelteChart			from './Page_0001_Chart.svelte';   

// ----------------------------------------------------
// --   DECLARATIONS
// ----------------------------------------------------


var data = [];
let data_filters = [];

	onMount(async () => {
		// fetch data
	   fetchData();
	});


  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
//  		       && is_echartsLoaded
  		       && is_dataLoaded
  		   )
  	  {
			is_dependenciesLoaded = true;
//			setTimeout(function(){ 
//				buildApplet();
//			 }, 
//			 1000); // NASTY HACK: to wait until DOM is processed
  		}
  }

  var is_echartsLoaded = false;
  function echartsLoaded() {
		is_echartsLoaded = true;
		dependenciesLoaded();
  }


  var is_dataLoaded = false;
  function fetchData() {
		is_dataLoaded = true;
		dependenciesLoaded();
  }

	onDestroy(() => { 
	});




// ----------------------------------------------------
// --   RUNTIME 
// ----------------------------------------------------


/*
				setTimeout(() => {
				    // do something nifty
  				}, 500 + Math.random() * 500);

*/

//$: run = is_dependenciesLoaded && fetchData() // <<-- should be hanlded in the onMount() ??

//$: display_chart = is_dependenciesLoaded;


$: {
	console.log(data_filters);
}

</script>

<style>

	.applet {
		width: inherit;
		height:550px;
	}

	.jsfiddle {
		width: inherit;
		height: inherit;
	}


</style>

<div class="applet">

	{#if is_dependenciesLoaded}
		<iframe class="jsfiddle" title="artififiddle/184bcskn"
         src="//jsfiddle.net/artififiddle/184bcskn/22/embedded/result/?embed_param_API_KEY=API_KEY&embed_param_CLIENT_ID=CLIENT_ID&embed_param_CLIENT_SECRET=CLIENT_SECRET&embed_param_CLIENT_SESSION=12345678" 
         allowfullscreen="allowfullscreen" 
         frameborder="0"></iframe>
	     
	{:else}
	<div>
			<p> Loading data and scripts and what not... </p>
	</div>

	{/if}
</div>
